import { SET_LOGIN_FIELD } from './constants';

export const setLoginField = payload => {
    return {
        type: SET_LOGIN_FIELD,
        payload,
    };
};
